import { Service } from "@seriously-rad/seriouslyrad-framework-core/Service";
import { INotificationHub } from "./NotificationHub";

export class NotificationHubService extends Service<INotificationHub>
{
}